import {moduleReducer} from "./moduleReducer";
import {serverReducer} from "./serverReducer";
import {rccReducer} from "./rccReducer";
import {spectroReducer} from "./spectroReducer";
import {helperReducer} from "./helperReducer";
import {licenseReducer} from "./licenseReducer";
import {setupReducer} from "./setupReducer";
import {loginReducer} from "./loginReducer";
import {settingsReducer} from "./settingsReducer";
import {langReducer} from "./langReducer";
import {globalReducer} from "./globalReducer";
import {navigationReducer} from "./navigationReducer";
import {barcodeReducer} from "./barcodeReducer";
import {virtualKeyboardReducer} from "./virtualKeyboardReducer";
import {searchPanelReducer} from "./searchPanelReducer";
import {formulaReducer} from "./formulaReducer";
import {favoritesTabReducer} from "./favoritesTabReducer";
import {customersReducer} from "./customersReducer";
import {customTabReducer} from "./customTabReducer";
import {statisticsTabReducer} from "./statisticsTabReducer";
import {matchingTabReducer} from "./matchingTabReducer";
import {qualityControlReducer} from "./qualityControlReducer";
import {myOrdersTabReducer} from "./myOrdersTabReducer";
import {toDispenseTabReducer} from "./toDispenseReducer";
import {ordersHistoryReducer} from "./ordersHistoryReducer";
import {spectroTabReducer} from "./spectroTabReducer";
import {intergammaOrderReducer} from "./intergammaOrderReducer";
import {intergammaMachineReducer} from "./intergammaMachineReducer";
import {filteringReducer} from "./filteringReducer";
import {pricingReducer} from "./pricingReducer";
import {importDataReducer} from "./importDataReducer";
import {stockReducer} from "./stockReducer";
import {machineReducer} from "./machineReducer";
import {ticketingReducer} from "./ticketingReducer";

const reducers = {
    module: moduleReducer,
    server: serverReducer,
    rcc: rccReducer,
    machine: machineReducer,
    spectro: spectroReducer,
    helper: helperReducer,
    license: licenseReducer,
    setup: setupReducer,
    login: loginReducer,
    settings: settingsReducer,
    lang: langReducer,
    global: globalReducer,
    navigation: navigationReducer,
    barcode: barcodeReducer,
    virtualKeyboard: virtualKeyboardReducer,
    pricing: pricingReducer,
    searchPanel: searchPanelReducer,
    formula: formulaReducer,
    filtering: filteringReducer,
    favoritesTab: favoritesTabReducer,
    customers: customersReducer,
    customTab: customTabReducer,
    statisticsTab: statisticsTabReducer,
    myOrders: myOrdersTabReducer,
    toDispense: toDispenseTabReducer,
    ordersHistory: ordersHistoryReducer,
    matchingTab: matchingTabReducer,
    qualityControl: qualityControlReducer,
    spectroTab: spectroTabReducer,
    importData: importDataReducer,
    intergammaOrder: intergammaOrderReducer,
    intergammaMachine: intergammaMachineReducer,
    stock: stockReducer,
    ticketing: ticketingReducer
};

export default reducers;
